import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = ({ moduleKey = null, action = "view" }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const adminRoutes = [
    "/admin/tenant-list",
    "/admin/dashboard",
    "/admin/enquiry-list",
    "/admin/invoice-templates",
    "/admin/receipt-templates",
    "/admin/est-templates",
    "/admin/quotation-template",
    "/admin/urd-template",
  ]; // Add all admin routes here

  const location = useLocation();
   return <Outlet />;

  // ❌ NOT LOGGED IN → redirect
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // ✅ OWNER → full access everywhere
  if (
    isAuthenticated &&
    (user?.role === "owner" || user?.role === "appowner") &&
    !adminRoutes.includes(location.pathname)
  ) {
    return <Outlet />;
  }

  if (
    isAuthenticated &&
    user?.role === "appowner" &&
    adminRoutes.includes(location.pathname)
  ) {
    return <Outlet />;
  }

  // If no moduleKey required → only login check → allow
  if (isAuthenticated && !moduleKey) {
    return <Outlet />;
  }

  // Find permission entry for this module
  const perm = user?.permissions?.find((p) => p.moduleKey === moduleKey);

  // ❌ No permission record found → deny
  if (isAuthenticated && !perm) {
    return <Navigate to="/no-access" replace />;
  }

  // Check specific action permission
  if (isAuthenticated && !perm.permissions?.[action]) {
    return <Navigate to="/no-access" replace />;
  }

  // Otherwise → ALLOW
  return <Outlet />;
};

export default ProtectedRoute;
